import getAccessToken from '../api/BearerToken';

export const TOKEN_ACCESSOR = { tokenGetter: getAccessToken } as const;
